import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RadMeterModelDetailsComponent } from './rad-meter-models/rad-meter-model-details/rad-meter-model-details.component';
import { RadMeterModelsComponent } from './rad-meter-models/rad-meter-models.component';
import { RadMetersDetailsComponent } from './rad-meters-details/rad-meters-details.component';
import { RadMetersTypesDetailsComponent } from './rad-meters-types/rad-meters-types-details/rad-meters-types-details.component';
import { RadMetersTypesComponent } from './rad-meters-types/rad-meters-types.component';
import { RadMetersUnitsDetailsComponent } from './rad-meters-units/rad-meters-units-details/rad-meters-units-details.component';
import { RadMetersUnitsComponent } from './rad-meters-units/rad-meters-units.component';
import { RadMetersComponent } from './rad-meters/rad-meters.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SharedModule } from 'src/app/modules/shared.module';
import { MetersCatalogComponent } from './meters-catalog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MetersCatalogSettingsComponent } from './meters-catalog-settings/meters-catalog-settings.component';



@NgModule({
  declarations: [
    MetersCatalogComponent,
    RadMetersComponent,
    RadMetersDetailsComponent,
    RadMetersUnitsComponent,
    RadMetersUnitsDetailsComponent,
    RadMetersTypesComponent,
    RadMetersTypesDetailsComponent,
    RadMeterModelsComponent,
    RadMeterModelDetailsComponent,
    MetersCatalogSettingsComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    HttpClientModule,
    ScrollingModule,
    HttpClientModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatRadioModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    MatGridListModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    DragDropModule,
    MatTreeModule,
    MatExpansionModule,
    MatOptionModule,
    MatSidenavModule,
    MatToolbarModule,
    DatePipe,
    QuillModule.forRoot(),
    SharedModule,
  ]
})
export class MetersCatalogModule { }
